export default function startAgentPolling(context) {
  const agentId = context.stores.auth.get().getUserId();
  context.gateways.conversationCount.requestAgentConversationCounts(agentId);
  context.gateways.routableInboxCounts.requestRoutableInboxCounts();
}
